import domReady from '@wordpress/dom-ready';
import manifest from '../manifest.json';

const HIDDEN_CLASS = 'form-action-is-hidden';
const SCROLL_OFFSET = 200;

function scrollToWithOffset(element) {
	requestAnimationFrame(() => {
		const top = element.getBoundingClientRect().top + window.scrollY;

		window.scrollTo({ top: top - SCROLL_OFFSET, behavior: 'smooth' });
	});
}

function toggleFormActionVisibility(wrapper, form, actionType, scrollIntoView) {
	if (actionType === 'show') {
		wrapper.classList.remove(HIDDEN_CLASS);

		if (scrollIntoView) {
			scrollToWithOffset(wrapper);
		}
	} else if (actionType === 'hide') {
		wrapper.classList.add(HIDDEN_CLASS);

		if (scrollIntoView && !form.classList.contains(HIDDEN_CLASS)) {
			scrollToWithOffset(form);
		}
	}
}

/**
 * Builds a Map from form ID (string) to wrappers that listen for that form.
 * Used to only run logic for wrappers connected to the submitted form.
 */
function buildFormIdToWrappersMap() {
	const wrappers = document.querySelectorAll(`.${manifest.blockJsClass}`);
	const map = new Map();

	for (const wrapper of wrappers) {
		const formId = wrapper.dataset.formActionFormId;

		if (!formId) {
			continue;
		}

		const key = String(formId);

		if (!map.has(key)) {
			map.set(key, []);
		}

		map.get(key).push(wrapper);
	}

	return map;
}

domReady(() => {
	const formIdToWrappers = buildFormIdToWrappersMap();

	if (formIdToWrappers.size === 0) {
		return;
	}

	window.addEventListener('esFormsAfterFormSubmitSuccess', ({ detail }) => {
		const { formId, esForms } = detail;

		if (!esForms?.store?.getStateFormElement) {
			return;
		}

		const submittedForm = esForms.store.getStateFormElement(formId);

		if (!submittedForm) {
			return;
		}

		const fId = submittedForm?.dataset?.formFid;

		if (!fId) {
			return;
		}

		const wrappersToUpdate = formIdToWrappers.get(String(fId));

		if (!wrappersToUpdate) {
			return;
		}

		for (const wrapper of wrappersToUpdate) {
			const actionType = wrapper.dataset.formActionType;
			const scrollIntoView = wrapper.dataset.formActionScrollIntoView === 'true';

			toggleFormActionVisibility(wrapper, submittedForm, actionType, scrollIntoView);
		}
	});
});
